import React from 'react';
import { useState, useEffect, useRef } from 'react';
import './classes/JobsInSportsBanner.css';
import { configData } from "../config";
import PhoneInput, { isValidPhoneNumber, getCountryCallingCode } from 'react-phone-number-input';
import ReCAPTCHA from "react-google-recaptcha";
import { useQuickApp, submitQuickAppStep1, isBlockedEmail, QUICK_APP_MESSAGES } from "./services/QuickAppService";
import { openQuickAppPopup } from "./QuickAppPopup";

// The "jobs in sports" landing pages: a full-width banner under the header with the
// "Apply Today" form on it, as on the Drupal site. Keyed on the page's node id.
//   image / mobileImage: files in /sites/jobs_in_sports_images on the Drupal site
//   sku: what the lead is filed under
//   button: the link shown under the page's course list
//   degrees: the page also shows the conferences placed on it and the Degrees tile
//   jobs: the list of jobs at the bottom of the page (see JobsInSportsList)
export const JOBS_IN_SPORTS_PAGES = {
    117136: {
        image: 'baseball_career_banner_img.png',
        mobileImage: 'baseball_career_banner_mob.png',
        sku: 'Baseball',
        degrees: true,
        jobs: {
            heading: 'Baseball Jobs Can Be Found Almost Everywhere:',
            items: [
                'MLB Player Personnel', 'Sports Radio', 'MLB General Manager', 'Sports Talk Show Host', 'MLB Agent',
                'Sports Commentator', 'MLB Scout', 'Play by Play Announcer', 'MLB Management', 'Press Box',
                'MLB Front Office', 'Sportscaster', 'MLB Game Operations', 'Sports Producer', 'MLB Sports Marketing',
                'Sideline Sports Reporter', 'MLB Media & Community Relations', 'Sports Anchor', 'MLB Account Manager',
                'Sports Broadcasting Internships', 'MLB Baseball Internships', 'Color Commentator', 'MLB Video Department',
                'Sports Media', 'MLB Video Coordinator or Asst. VC', 'Public Relations', 'MiLB Player Personnel',
                'Sports & Entertainment Communication', 'MiLB General Manager', 'Sports Marketing', 'MiLB Agent',
                'Marketing Professional Athletes', 'MiLB Scout', 'New Media Communications', 'MiLB Management',
                'Social Networking for a professional team', 'MiLB Front Office', 'Team Sports Blogger', 'MiLB Game Operations',
                'Sports Information Director (SID) for a university', 'MiLB Sports Marketing',
                'Journalism jobs in radio, TV, internet & print', 'MiLB Media & Community Relations', 'Fan Communications',
                'MiLB Account Manager', 'Marketing Communications', 'MiLB Baseball Internships', 'Brand Building',
                'MiLB Video Department', 'Dugout Reporter', 'MiLB Video Coordinator or Asst. VC',
                'Premium Club & Luxury Suite Sales', 'Coaching', 'Loyalty Programs', 'Scouting',
                'Account Executive & Inside Sales', 'Player Development', 'Brand Activation', 'Player Personnel',
                'Customer Relationship Management', 'Director of Scouting', 'Sponsorship Sales', 'Assistant General Manager',
                'Community Relations', 'General Manager', 'Event Planning', 'Sports Announcing', 'Digital Video Editing',
                'Baseball Analyst',
            ],
        },
    },
    121534: {
        image: 'basketball_career_banner_img_new.png',
        mobileImage: 'basketball_career_banner_mob_new.png',
        sku: 'Basketball',
        degrees: true,
        jobs: {
            heading: 'Basketball Jobs Can Be Found Almost Everywhere:',
            items: [
                'NBA Player Personnel', 'Sports Radio', 'NBA General Manager', 'Sports Talk Show Host', 'NBA Agent',
                'Sports Commentator', 'NBA Scout', '"Play by Play" Announcer', 'NBA Management', 'Press Box',
                'NBA Front Office', 'Sportscaster', 'NBA Game Operations', 'Sports Producer', 'NBA Sports Marketing',
                'Sports Reporter', 'NBA Media & Community Relations', 'Sports Anchor', 'NBA Account Manager',
                'Sports Broadcasting Internships', 'NBA Basketball Internships', 'Color Commentator', 'NBA Video Department',
                'Sports Media', 'NBA Video Coordinator or Asst. VC', 'Public Relations', 'NCAA Player Personnel',
                'Sports & Entertainment Communication', 'NCAA General Manager', 'Sports Marketing', 'NCAA Agent',
                'Marketing Professional Athletes', 'NCAA Scout', 'New Media Communications', 'NCAA Management',
                'Social Networking for a professional team', 'NCAA Front Office', 'Team Sports Blogger', 'NCAA Game Operations',
                'Sports Information Director (SID) for a university', 'NCAA Sports Marketing',
                'Journalism jobs in radio, TV, internet & print', 'NCAA Media & Community Relations', 'Fan Communications',
                'NCAA Account Manager', 'Marketing Communications', 'NCAA Baseball Internships', 'Brand Building',
                'NCAA Video Department', 'Dugout Reporter', 'NCAA Video Coordinator or Asst. VC',
                'Premium Club & Luxury Suite Sales', 'Basketball Coaching', 'Loyalty Programs', 'Basketball Scouting',
                'Account Executive & Inside Sales', 'Basketball Player Development', 'Brand Activation', 'Player Personnel',
                'Customer Relationship Management', 'Director of Basketball Scouting', 'Sponsorship Sales',
                'Assistant General Manager', 'Community Relations', 'General Manager', 'Event Planning', 'Sports Announcing',
                'Digital Video Editing', 'Basketball Analyst',
            ],
        },
    },
    3731: { image: 'football_career_banner_img.png', mobileImage: 'football_career_banner_mob.png', sku: 'Football', degrees: true },
    121533: {
        image: 'hockey_sports_career_desk.png',
        mobileImage: 'hockey_sports_career_mobile.png',
        sku: 'Hockey',
        degrees: true,
        jobs: {
            heading: 'Hockey Jobs Can Be Found Almost Everywhere:',
            items: [
                'NHL Player Personnel', 'Sports Radio', 'NHL General Manager', 'Sports Talk Show Host', 'NHL Agent',
                'Sports Commentator', 'NHL Scout', 'Play by Play Announcer', 'NHL Management', 'Press Box',
                'NHL Front Office', 'Sportscaster', 'NHL Game Operations', 'Sports Producer', 'NHL Sports Marketing',
                'Sports Reporter', 'NHL Media & Community Relations', 'Sports Anchor', 'NHL Account Manager',
                'Sports Broadcasting Internships', 'NHL Hockey Internships', 'Color Commentator', 'NHL Video Department',
                'Sports Media', 'NHL Video Coordinator or Asst. VC', 'Public Relations', 'NCAA Player Personnel',
                'Sports & Entertainment Communication', 'NCAA General Manager', 'Sports Marketing', 'NCAA Agent',
                'Marketing Professional Athletes', 'NCAA Scout', 'New Media Communications', 'NCAA Management',
                'Social Networking for a professional team', 'NCAA Front Office', 'Team Sports Blogger', 'NCAA Game Operations',
                'Sports Information Director (SID) for a university', 'NCAA Sports Marketing',
                'Journalism jobs in radio, TV, internet & print', 'NCAA Media & Community Relations', 'Fan Communications',
                'NCAA Account Manager', 'Marketing Communications', 'NCAA Hockey Internships', 'Brand Building',
                'NCAA Video Department', 'Dugout Reporter', 'NCAA Video Coordinator or Asst. VC',
                'Premium Club & Luxury Suite Sales', 'Hockey Coaching', 'Loyalty Programs', 'Hockey Scouting',
                'Account Executive & Inside Sales', 'Hockey Player Development', 'Brand Activation', 'Player Personnel',
                'Customer Relationship Management', 'Director of Hockey Scouting', 'Sponsorship Sales',
                'Assistant General Manager', 'Community Relations', 'General Manager', 'Event Planning', 'Sports Announcing',
                'Digital Video Editing', 'Hockey Analyst',
            ],
        },
    },
    184924: {
        image: 'sports_agent_banner_img.png',
        mobileImage: 'sports_agent_banner_tab.png',
        sku: 'Sports Agent',
        button: { label: 'Sports Agent Salaries', link: '/program/salaries' },
    },
    121535: {
        image: 'Soccer_Landing_Page_Banner.png',
        mobileImage: 'jobs_in_sports_soccer.png',
        sku: 'Soccer',
        degrees: true,
        jobs: {
            heading: 'Soccer Jobs Can Be Found Almost Everywhere:',
            image: '/images/soccer_map.png',
            items: [
                'EPL Player Personnel', 'Soccer Player Development', 'EPL General Manager', 'Player Personnel', 'EPL Agent',
                'Director of Soccer Scouting', 'EPL Scout', 'Assistant General Manager', 'EPL Management', 'General Manager',
                'EPL Front Office', 'Sports Announcing', 'EPL Game Operations', 'Soccer Analyst', 'EPL Sports Marketing',
                'Sports Radio', 'EPL Media & Community Relations', 'Sports Talk Show Host', 'EPL Account Manager',
                'Sports Commentator', 'EPL Basketball Internships', 'On-field Announcer', 'EPL Video Department', 'Press Box',
                'EPL Video Coordinator or Asst. VC', 'Sportscaster', 'MLS Player Personnel', 'Sports Producer',
                'MLS General Manager', 'Sports Reporter', 'MLS Agent', 'Sports Anchor', 'MLS Scout',
                'Sports Broadcasting Internships', 'MLS Management', 'Color Commentator', 'MLS Front Office', 'Sports Media',
                'MLS Game Operations', 'Public Relations', 'MLS Sports Marketing', 'Sports & Entertainment Communications',
                'MLS Media & Community Relations', 'Sports Marketing', 'MLS Account Manager', 'Marketing Professional Athletes',
                'MLS Basketball Internships', 'New Media Communications', 'MLS Video Department',
                'Social Networking for a professional team', 'MLS Video Coordinator or Asst. VC', 'Team Sports Blogger',
                'MLS Player Personnel', 'Sports Information Director (SID) for a university', 'MLS General Manager',
                'Journalism jobs in radio, TV, internet & print', 'La Liga Agent', 'Fan Communications', 'La Liga Scout',
                'Marketing Communications', 'La Liga Management', 'Brand Building', 'La Liga Front Office',
                'Premium Club & Luxury Suite Sales', 'La Liga Game Operations', 'Loyalty Programs', 'La Liga Sports Marketing',
                'Account Executive & Inside Sales', 'La Liga Account Manager', 'Brand Activation',
                'La Liga Media & Community Relations', 'Customer Relationship Management', 'La Liga Video Department',
                'Sponsorship Sales', 'La Liga Video Coordinator or Asst. VC', 'Community Relations', 'Soccer Coaching',
                'Event Planning', 'Soccer Scouting', 'Digital Video Editing',
            ],
        },
    },
};

const JobsInSportsBanner = ({ page }) => {
    const app_url = configData.APP_URL;
    const images_url = configData.DRUPAL_DOMAIN_URL + '/sites/jobs_in_sports_images/';
    const banner = JOBS_IN_SPORTS_PAGES[page?.nid];
    const recaptchaRef = useRef(null);

    const [formData, setFormData] = useState({
        fname: '',
        lname: '',
        email: '',
        phone: `+${getCountryCallingCode('US')}`,
        fteam: '',
        fcity: '',
        fcountry: 'United States',
        fstate: '',
        fprovince: '',
        field_text_me_with_news_offers: 0,
        sku: banner?.sku || '',
        page_type: 'jobs_in_sports',
        pageURL: window.location.href,
    });
    const [countriesList, setCountriesList] = useState({});
    const [statelist, setStateList] = useState({});
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);
    // The form is step 1 of the application: once it is saved, steps 2 and 3 follow in a popup
    const application = useQuickApp();

    useEffect(() => {
        retrieveList('smwwcountries/getcountrieslist', setCountriesList);
        retrieveList('smwwstates/getstatelist', setStateList);
    }, []);

    async function retrieveList(path, setList) {
        try {
            const response = await fetch(app_url + path, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const responsedata = await response.json();
            setList(responsedata.data.result || {});
        } catch (err) {
            console.error(err);
        }
    }

    if (!banner) return null;

    // States are asked for the US and Canada, a province for everywhere else
    const showState = formData.fcountry === 'United States' || formData.fcountry === 'Canada';

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setFormData(prev => ({ ...prev, [name]: checked ? 1 : 0 }));
        } else if (name === 'fcountry') {
            setFormData(prev => ({ ...prev, fcountry: value, fstate: '', fprovince: '' }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    // The first problem found, in the order the Drupal form checked them
    const validate = (data) => {
        if (!data.fname.trim()) return 'Please enter your first name.';
        if (!data.lname.trim()) return 'Please enter your last name.';
        if (!/^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(data.email.trim())) return 'Please enter a valid email address.';
        if (isBlockedEmail(data.email)) return QUICK_APP_MESSAGES.email_blocked;
        if (!data.phone || !isValidPhoneNumber(data.phone)) return 'Please fill in valid primary phone number.';
        if (!data.fcountry) return 'Please Select Country';
        // "-" is "Outside the US or Canada", which is not a state of the country chosen
        if (showState && (!data.fstate || data.fstate === '-')) return 'Please Select State';
        if (!data.fcity.trim()) return 'Please enter your city.';
        if (!data.fteam.trim()) return 'Please enter your favorite team.';
        if (!recaptchaRef.current?.getValue()) return "Please verify you're not a robot.";
        return '';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (saving) return;

        const formError = validate(formData);
        setError(formError);
        if (formError) return;

        setSaving(true);
        // Step 1 of the application (application/step1), as the Drupal form posts it
        const saved = await submitQuickAppStep1(formData, countriesList);
        setSaving(false);
        if (saved) {
            openQuickAppPopup();
        } else {
            setError('Something went wrong. Please try again.');
        }
    };

    return (
        // jobs_in_sports_banner is the Drupal class: some page bodies carry their own banner heights for it
        <div className="jobs-in-sports-banner jobs_in_sports_banner" style={{ '--jobs-banner-image': `url("${images_url + banner.image}")` }}>
            {/* Shown instead of the background on tablets and phones */}
            <img className="jobs-in-sports-banner__mobile-image" src={images_url + banner.mobileImage} alt="" />

            <div className="jobs-in-sports-banner__form">
                <div className="jobs-in-sports-banner__title">APPLY TODAY</div>

                {application ? (
                    application.stage === 4 ? (
                    <div className="jobs-in-sports-banner__thanks">
                        Thank you for your interest!<br /> Someone from SMWW will be contacting you soon.
                    </div>
                    ) : (
                    <div className="sqa-resume">
                        <p>Thank you, {application.state.first_name}! You’re one step in.</p>
                        <button type="button" className="sqa-btn" onClick={openQuickAppPopup}>Finish your application</button>
                    </div>
                    )
                ) : (
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="jobs-in-sports-banner__field">
                            <label htmlFor="jobs-fname">First Name</label>
                            <input id="jobs-fname" name="fname" type="text" value={formData.fname} onChange={handleChange} />
                        </div>
                        <div className="jobs-in-sports-banner__field">
                            <label htmlFor="jobs-lname">Last Name</label>
                            <input id="jobs-lname" name="lname" type="text" value={formData.lname} onChange={handleChange} />
                        </div>
                        <div className="jobs-in-sports-banner__field">
                            <label htmlFor="jobs-email">Email</label>
                            <input id="jobs-email" name="email" type="text" value={formData.email} onChange={handleChange} />
                        </div>
                        <div className="jobs-in-sports-banner__field">
                            <label htmlFor="jobs-phone">Phone</label>
                            <PhoneInput
                                id="jobs-phone"
                                international
                                countryCallingCodeEditable={false}
                                defaultCountry="US"
                                value={formData.phone}
                                onChange={(phone) => setFormData(prev => ({ ...prev, phone: phone || '' }))}
                            />
                        </div>
                        <div className="jobs-in-sports-banner__field">
                            <label htmlFor="jobs-fcity">City</label>
                            <input id="jobs-fcity" name="fcity" type="text" value={formData.fcity} onChange={handleChange} />
                        </div>
                        <div className="jobs-in-sports-banner__field">
                            <label htmlFor="jobs-fcountry">Country</label>
                            <select id="jobs-fcountry" name="fcountry" value={formData.fcountry} onChange={handleChange}>
                                <option value="">Select Country</option>
                                {Object.keys(countriesList).map(item => (
                                    <option key={countriesList[item].label} value={countriesList[item].label}>{countriesList[item].label}</option>
                                ))}
                            </select>
                        </div>
                        {showState ? (
                            <div className="jobs-in-sports-banner__field">
                                <label htmlFor="jobs-fstate">State</label>
                                <select id="jobs-fstate" name="fstate" value={formData.fstate} onChange={handleChange}>
                                    <option value="">Select a State or Province</option>
                                    <option value="-">Outside the US or Canada</option>
                                    {Object.keys(statelist).map(state => (
                                        <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>
                                    ))}
                                </select>
                            </div>
                        ) : (
                            <div className="jobs-in-sports-banner__field">
                                <label htmlFor="jobs-fprovince">Province</label>
                                <input id="jobs-fprovince" name="fprovince" type="text" value={formData.fprovince} onChange={handleChange} />
                            </div>
                        )}
                        <div className="jobs-in-sports-banner__field">
                            <label htmlFor="jobs-fteam">Favorite Team or Club?</label>
                            <input id="jobs-fteam" name="fteam" type="text" value={formData.fteam} onChange={handleChange} />
                        </div>
                        <div className="jobs-in-sports-banner__field">
                            <label className="jobs-in-sports-banner__consent">
                                <input name="field_text_me_with_news_offers" type="checkbox" checked={formData.field_text_me_with_news_offers === 1} onChange={handleChange} />
                                {' '}Text me with news and offers
                            </label>
                        </div>
                        <div className="jobs-in-sports-banner__field">
                            <div className="jobs-in-sports-banner__recaptcha">
                                <ReCAPTCHA ref={recaptchaRef} sitekey={configData.GOOGLE_RECAPTCHA_SITE_KEY} />
                            </div>
                        </div>
                        <div className="jobs-in-sports-banner__actions">
                            {error && <span className="jobs-in-sports-banner__error">{error}</span>}
                            <button type="submit" aria-disabled={saving ? "true" : undefined} style={saving ? { opacity: 0.7 } : undefined}>Submit</button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default JobsInSportsBanner;
